module.exports = __webpack_public_path__ + "static/media/receive-success-mouse2.6bfab9b6.png";